var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"footer"},[_vm._v("© 2023 blokchain.cn   "),(this.$i18n.locale=='zh')?_c('span',[_vm._v("|   ")]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }